/**
 * @deprecated
 * Don't add new route names, use route URLs directly.
 * See `RoutePaths` and `EnterprisePaths` from `@mews-commander/ui` for all possible paths.
 */
export enum RouteName {
    AccountMatchAndMerge = 'AccountMatchAndMerge',
    AccountingCategoryDetail = 'AccountingCategoryDetail',
    AccountingCategoryIndex = 'AccountingCategoryIndex',
    AccountingConfigurationAccountingCategory = 'AccountingConfigurationAccountingCategory',
    AccountingConfigurationDetail = 'AccountingConfigurationDetail',
    AccountingLedgerReportIndex = 'AccountingLedgerReportIndex',
    AccountingReportIndex = 'AccountingReportIndex',
    ActivityReportIndex = 'ActivityReportIndex',
    AgeCategoryIndex = 'AgeCategoryIndex',
    AnalyticsImport = 'AnalyticsImport',
    AnalyticsIndex = 'AnalyticsIndex',
    AvailabilityAdjustmentCreate = 'AvailabilityAdjustmentCreate',
    AvailabilityBlockActionLog = 'AvailabilityBlockActionLog',
    AvailabilityBlockCreate = 'AvailabilityBlockCreate',
    AvailabilityBlockDashboard = 'AvailabilityBlockDashboard',
    AvailabilityBlockDetail = 'AvailabilityBlockDetail',
    AvailabilityBlockReportIndex = 'AvailabilityBlockReportIndex',
    AvailabilityBlockReportScheduleDetail = 'AvailabilityBlockReportScheduleDetail',
    AvailabilityReportIndex = 'AvailabilityReportIndex',
    BillActionLog = 'BillActionLog',
    BillChangeAddress = 'BillChangeAddress',
    BillClose = 'BillClose',
    BillDetail = 'BillDetail',
    BillPreviewCreatePreview = 'BillPreviewCreatePreview',
    BillPreviewCreateProforma = 'BillPreviewCreateProforma',
    BillReportIndex = 'BillReportIndex',
    BillingAccount = 'BillingAccount',
    BillingGroup = 'BillingGroup',
    BookingEngineIndex = 'BookingEngineIndex',
    BusinessIntelligenceIndex = 'BusinessIntelligenceIndex',
    BusinessSegmentIndex = 'BusinessSegmentIndex',
    CalendarEventIndex = 'CalendarEventIndex',
    CancellationPolicyIndex = 'CancellationPolicyIndex',
    CashierDefault = 'CashierDefault',
    CashierDetail = 'CashierDetail',
    CashierIndex = 'CashierIndex',
    ChannelManagerClientDetail = 'ChannelManagerClientDetail',
    ChannelManagerQueueItemIndex = 'ChannelManagerQueueItemIndex',
    ChargebackReportIndex = 'ChargebackReportIndex',
    CheckInForm = 'CheckInForm',
    CheckoutReportIndex = 'CheckoutReportIndex',
    CityTaxReportIndex = 'CityTaxReportIndex',
    CompanyActionLog = 'CompanyActionLog',
    CompanyCreate = 'CompanyCreate',
    CompanyDashboard = 'CompanyDashboard',
    CompanyDetail = 'CompanyDetail',
    CompanyDisplayMerge = 'CompanyDisplayMerge',
    CompanyDownloadFile = 'CompanyDownloadFile',
    CompanyReportIndex = 'CompanyReportIndex',
    ConnectorClientDetail = 'ConnectorClientDetail',
    CounterIndex = 'CounterIndex',
    CreditCardReportIndex = 'CreditCardReportIndex',
    CurrencyAcceptanceCreate = 'CurrencyAcceptanceCreate',
    CurrencyAcceptanceIndex = 'CurrencyAcceptanceIndex',
    CustomLinkIndex = 'CustomLinkIndex',
    CustomerActionLog = 'CustomerActionLog',
    CustomerCreate = 'CustomerCreate',
    CustomerDashboard = 'CustomerDashboard',
    CustomerDetail = 'CustomerDetail',
    CustomerDisplayMerge = 'CustomerDisplayMerge',
    CustomerDownloadFile = 'CustomerDownloadFile',
    CustomerInternals = 'CustomerInternals',
    CustomerProfileReportIndex = 'CustomerProfileReportIndex',
    CustomerRegistrationCard = 'CustomerRegistrationCard',
    CustomerReservationRegistrationCards = 'CustomerReservationRegistrationCards',
    CustomerStatisticReportIndex = 'CustomerStatisticReportIndex',
    CustomerTableBookings = 'CustomerTableBookings',
    DashboardIndex = 'DashboardIndex',
    DepartmentIndex = 'DepartmentIndex',
    DeviceCommandIndex = 'DeviceCommandIndex',
    DeviceHubIndex = 'DeviceHubIndex',
    DigitalKeysConfiguration = 'DigitalKeysConfiguration',
    EnterpriseBuilderQueueItemsIndex = 'InstallationEnterpriseBuilderQueueItemsIndex',
    EnterpriseCancellationPoliciesIndex = 'EnterpriseCancellationPoliciesIndex',
    EnterpriseDetail = 'EnterpriseDetail',
    EnterpriseIntegrationCreate = 'EnterpriseIntegrationCreate',
    EnterpriseIntegrationMarketplace = 'EnterpriseIntegrationMarketplace',
    EnterpriseIntegrationReportIndex = 'EnterpriseIntegrationReportIndex',
    EnterprisePaymentPoliciesIndex = 'EnterprisePaymentPoliciesIndex',
    EnterpriseProfileDetail = 'EnterpriseProfileDetail',
    EnterpriseRateManagementRateGroupsIndex = 'EnterpriseRateManagementRateGroupsIndex',
    EnterpriseRateManagementRateUpload = 'EnterpriseRateManagementRateUpload',
    EnterpriseRelationshipReportGroups = 'EnterpriseRelationshipReportGroups',
    EnterpriseRelationshipReportIndex = 'EnterpriseRelationshipReportIndex',
    EventReportIndex = 'EventReportIndex',
    ExportIndex = 'ExportIndex',
    ExportQueue = 'ExportQueue',
    ExportScheduleDetail = 'ExportScheduleDetail',
    ExportScheduleIndex = 'ExportScheduleIndex',
    ExportTargetIndex = 'ExportTargetIndex',
    FinanceCityLedger = 'FinanceLedgersCityLedger',
    FinanceDepositLedger = 'FinanceDepositLedger',
    FinanceGuestLedger = 'FinanceLedgersGuestLedger',
    FinancialServicesCapital = 'FinancialServicesCapital',
    GoLiveAuditsSetup = 'GoLiveAuditsSetup',
    GuestExperienceEnterprises = 'GuestExperienceEnterprises',
    GuestExperienceWhitelistedUserEmails = 'GuestExperienceWhitelistedUserEmails',
    GuestInHouseReportIndex = 'GuestInHouseReportIndex',
    GuestInHouseReportScheduleDetail = 'GuestInHouseReportScheduleDetail',
    GuestsInHouseReportIndex = 'GuestsInHouseReportIndex',
    HomeResetPassword = 'HomeResetPassword',
    HomeSignIn = 'HomeSignIn',
    ImportQueueItemIndex = 'ImportQueueItemIndex',
    InstallationQueueItemIndex = 'InstallationQueueItemIndex',
    IntegrationClientIndex = 'IntegrationClientIndex',
    InventoryUpdateIndex = 'InventoryUpdateIndex',
    JobExecutionIndex = 'JobExecutionIndex',
    JobIndex = 'JobIndex',
    KioskIndex = 'KioskIndex',
    MailQueueItemIndex = 'MailQueueItemIndex',
    MailTemplateIndex = 'MailTemplateIndex',
    ManagerReportIndex = 'ManagerReportIndex',
    MerchantBalanceReportIndex = 'MerchantBalanceReportIndex',
    MessageThreadIndex = 'MessageThreadIndex',
    NewManagerReport = 'NewManagerReport',
    NotificationVisit = 'NotificationVisit',
    OccupancyReportIndex = 'OccupancyReportIndex',
    OpenPayoutDetail = 'OpenPayoutDetail',
    OrderItemActionLog = 'OrderItemActionLog',
    OutletIndex = 'OutletIndex',
    PaymentChargePreauthorization = 'PaymentChargePreauthorization',
    PaymentCreateCreditCardPayment = 'PaymentCreateCreditCardPayment',
    PaymentCreatePaymentTerminalCommand = 'PaymentCreatePaymentTerminalCommand',
    PaymentCreatePreauthorization = 'PaymentCreatePreauthorization',
    PaymentDetail = 'PaymentDetail',
    PaymentIndex = 'PaymentIndex',
    PaymentReportIndex = 'PaymentReportIndex',
    PaymentUpdatePreauthorization = 'PaymentUpdatePreauthorization',
    PayoutReportDetail = 'PayoutReportDetail',
    PayoutReportIndex = 'PayoutReportIndex',
    PolicyIndex = 'PolicyIndex',
    PostingJournalReportIndex = 'PostingJournalReportIndex',
    ProductCheckListIndex = 'ProductCheckListIndex',
    ProductDetail = 'ProductDetail',
    ProductIndex = 'ProductIndex',
    ProductReportIndex = 'ProductReportIndex',
    ProductRuleIndex = 'ProductRuleIndex',
    ProductServiceAccountingIndex = 'ProductServiceAccountingIndex',
    ProductServiceCreate = 'ProductServiceCreate',
    ProductServiceDetail = 'ProductServiceDetail',
    ProductServiceOrderCreate = 'ProductServiceOrderCreate',
    ProductServiceOrderDetail = 'ProductServiceOrderDetail',
    ProfileIndex = 'ProfileIndex',
    ProfilePreferences = 'ProfilePreferences',
    ProfileSecurity = 'ProfileSecurity',
    PromotedServiceAssignmentIndex = 'PromotedServiceAssignmentIndex',
    RateCreate = 'RateCreate',
    RateDetail = 'RateDetail',
    RateGroupIndex = 'RateGroupIndex',
    RateIndex = 'RateIndex',
    RatePricing = 'RatePricing',
    RegistrationCardConfigurationDetail = 'RegistrationCardConfigurationDetail',
    ReportExportDetail = 'ReportExportDetail',
    ReservationCreate = 'ReservationCreate',
    ReservationCreateDeposit = 'ReservationCreateDeposit',
    ReservationDashboard = 'ReservationDashboard',
    ReservationDetail = 'ReservationDetail',
    ReservationDetailActionLog = 'ReservationDetailActionLog',
    ReservationDetailContracts = 'ReservationDetailContracts',
    ReservationDetailGroup = 'ReservationDetailGroup',
    ReservationDetailItems = 'ReservationDetailItems',
    ReservationDetailMailing = 'ReservationDetailMailing',
    ReservationDetailPricing = 'ReservationDetailPricing',
    ReservationDetailProperties = 'ReservationDetailProperties',
    ReservationDetailStatus = 'ReservationDetailStatus',
    ReservationDetailSummary = 'ReservationDetailSummary',
    ReservationEventLog = 'ReservationEventLog',
    ReservationGroupDetail = 'ReservationGroupDetail',
    ReservationMembershipExport = 'ReservationMembershipExport',
    ReservationOverviewReportIndex = 'ReservationOverviewReportIndex',
    ReservationReportIndex = 'ReservationReportIndex',
    ResourceBlockCreate = 'ResourceBlockCreate',
    ResourceBlockDetail = 'ResourceBlockDetail',
    ResourceBlockSimpleDetail = 'ResourceBlockSimpleDetail',
    ResourceCategoryCreate = 'ResourceCategoryCreate',
    ResourceCategoryDetail = 'ResourceCategoryDetail',
    ResourceCategoryIndex = 'ResourceCategoryIndex',
    ResourceDetail = 'ResourceDetail',
    ResourceFeatureDetail = 'ResourceFeatureDetail',
    ResourceFeatureIndex = 'ResourceFeatureIndex',
    ResourceIndex = 'ResourceIndex',
    ResourceSetOutOfService = 'ResourceSetOutOfService',
    ResourceState = 'ResourceState',
    ResourceStatusReportIndex = 'ResourceStatusReportIndex',
    RestrictionCalendar = 'RestrictionCalendar',
    RestrictionClear = 'RestrictionClear',
    RestrictionCreate = 'RestrictionCreate',
    RestrictionDetail = 'RestrictionDetail',
    RestrictionIndex = 'RestrictionIndex',
    RoutingRuleCreate = 'RoutingRuleCreate',
    RoutingRuleDetail = 'RoutingRuleDetail',
    RoutingRuleDetailLegacy = 'RoutingRuleDetailLegacy',
    RoutingRuleIndex = 'RoutingRuleIndex',
    SecuritySettings = 'SecuritySettings',
    SellLimits = 'SellLimits',
    ServiceDocumentIndex = 'ServiceDocumentIndex',
    ServiceIndex = 'ServiceIndex',
    ServiceOrderDetail = 'ServiceOrderDetail',
    ServiceReportArchive = 'ServiceReportArchive',
    ServiceReportOrdersToProcess = 'ServiceReportOrdersToProcess',
    SettlementRuleIndex = 'SettlementRuleIndex',
    TaskCreate = 'TaskCreate',
    TaskDetail = 'TaskDetail',
    TaskReportIndex = 'TaskReportIndex',
    TerminalOrderIndex = 'TerminalOrderIndex',
    TextMessaging = 'TextMessaging',
    TimeSpentReportIndex = 'TimeSpentReportIndex',
    TravelAgencyContractDetail = 'TravelAgencyContractDetail',
    TravelAgencyContractReportIndex = 'TravelAgencyContractReportIndex',
    TrialBalanceIndex = 'TrialBalanceIndex',
    UserGroupsListIndex = 'UserGroupsListIndex',
    UserManagementCentralUsersIndex = 'UserManagementCentralUsersIndex',
    UserManagementMultiPropertyCentralUsersIndex = 'UserManagementMultiPropertyCentralUsersIndex',
    UserManagementMultiPropertyPropertyUsersIndex = 'UserManagementMultiPropertyPropertyUsersIndex',
    UserManagementPropertyUsersIndex = 'UserManagementPropertyUsersIndex',
    VisitCreate = 'VisitCreate',
    VisitDefaultPricing = 'VisitDefaultPricing',
    VisitDetail = 'VisitDetail',
    VoucherCreate = 'VoucherCreate',
    VoucherDetail = 'VoucherDetail',
    VoucherIndex = 'VoucherIndex',
}
